import React, { useEffect } from 'react';
import { useStore } from '@hooks';
import { Loader } from '@ui';
import { observer } from 'mobx-react';
import { STRIPE_STATUS_COMPONENT } from '../../constants';
import { StyledBlur, StyledWrapper } from '../../styled';
import NoAccount from '../NoAccount';

const StripeAccountStatus = observer(() => {
    const { accountsStore } = useStore();
    const { stripeAccountStatus, currentAccount } = accountsStore;
    const stripeAccountId = currentAccount?.stripeSettings?.stripeAccountId;

    useEffect(() => {
        if (stripeAccountId) {
            (async () => {
                await accountsStore.stripeAccountInfo();
            })();
        }
    }, [stripeAccountId]);

    const Component = STRIPE_STATUS_COMPONENT[stripeAccountStatus] || NoAccount;

    return (
        <StyledWrapper>
            {accountsStore.accountStatusPending ? <Loader /> : null}
            <StyledBlur $isLoading={accountsStore.accountStatusPending}>
                <Component />
            </StyledBlur>
        </StyledWrapper>
    );
});

export default StripeAccountStatus;
